import { useState } from 'react';

const DEFAULT_PROPS = { isInitialOpen: false };

export const useModal = ({ isInitialOpen } = DEFAULT_PROPS) => {
    const [isOpen, setIsOpen] = useState(isInitialOpen);

    const toggleModal = () => {
        setIsOpen(prevState => !prevState);
    };

    return {
        isOpen,
        toggleModal,
    };
};
